var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-card"},[_c('div',{staticClass:"card-tag"},[_vm._t("tag")],2),_vm._v(" "),_c('div',{staticClass:"container-card"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }